export const PATREON_JOIN_URL = "https://www.patreon.com/Wirder/join";
